import {
  ENUM_PERMISSIONS_LIST,
  ENUM_PERMISSIONS_LIST_SUCCESS,
  ENUM_PERMISSIONS_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
}

const EnumPermissions = (state = initialState, action) => {
  switch (action.type) {
    case ENUM_PERMISSIONS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case ENUM_PERMISSIONS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case ENUM_PERMISSIONS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default EnumPermissions
